export default "__VITE_ASSET__DwgV0Ooo__"